import React, { useState } from "react";
import { View, Text, Image, Pressable, StyleSheet } from "react-native";
import { textStyle, useScale } from "../styles";
import { trackButton, Button, View as MetricView } from "../services/metrics";
import GrownUpsModal from "./GrownUpsModal";

const icHandStop = require("../assets/icons/ic-hand-stop.png");
const icQrScan = require("../assets/icons/ic-qr-scan.png");

const BANNER_BG = "#EBE2C8";
const BANNER_ICON_BG = "#D9C589";
const TEXT_DARK = "#1E2034";
const BUTTON_BG = "#130A45";

interface GrownUpsBannerProps {
  title: string;
  description?: string;
}

export default function GrownUpsBanner({
  title,
  description = "Ask your parent to scan the QR code to follow the instructions and learn more.",
}: GrownUpsBannerProps) {
  const { s } = useScale();
  const [modalVisible, setModalVisible] = useState(false);

  return (
    <>
      <View style={[styles.banner, { paddingVertical: s(24), paddingHorizontal: s(32) }]}>
        <View style={[styles.bannerIcon, { width: s(102), height: s(102), borderRadius: s(51) }]}>
          <Image
            source={icHandStop}
            style={{ width: s(64), height: s(64) }}
            resizeMode="contain"
            tintColor={TEXT_DARK}
          />
        </View>

        <View style={styles.bannerBody}>
          <Text style={styles.bannerTitle}>{title}</Text>
          <Text style={styles.bannerDescription}>{description}</Text>
        </View>

        <Pressable
          style={[styles.scanButton, { width: s(220), height: s(64), borderRadius: s(32), paddingHorizontal: s(20) }]}
          onPress={() => { trackButton(MetricView.VPCEnablement, Button.VPCEnablement.ScanCode); setModalVisible(true); }}
          accessibilityRole="button"
          accessibilityLabel="Scan Code"
        >
          <Image
            source={icQrScan}
            style={{ width: s(32), height: s(32) }}
            resizeMode="contain"
            tintColor="#FFFFFF"
          />
          <Text style={styles.scanButtonText}>Scan Code</Text>
        </Pressable>
      </View>

      <GrownUpsModal visible={modalVisible} onClose={() => setModalVisible(false)} />
    </>
  );
}

const styles = StyleSheet.create({
  // --- Banner ---
  banner: {
    position: "absolute",
    bottom: 0,
    left: 0,
    right: 0,
    backgroundColor: BANNER_BG,
    flexDirection: "row",
    alignItems: "center",
    gap: 24,
  },
  bannerIcon: {
    backgroundColor: BANNER_ICON_BG,
    alignItems: "center",
    justifyContent: "center",
  },
  bannerBody: {
    flex: 1,
  },
  bannerTitle: {
    color: TEXT_DARK,
    fontSize: 22,
    lineHeight: 26,
    ...textStyle.heading,
  },
  bannerDescription: {
    color: TEXT_DARK,
    fontSize: 22,
    lineHeight: 26,
    ...textStyle.body,
  },
  scanButton: {
    backgroundColor: BUTTON_BG,
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "row",
    gap: 8,
  },
  scanButtonText: {
    color: "#FFFFFF",
    fontSize: 16,
    ...textStyle.body,
  },
});
